export const translations = {
    watch: {
        en: "Watch",
        de: "Ansehen",
        es: "Ver",
        fr: "Regarder",
        it: "Guarda",
        ja: "見る",
        ko: "보러 가기",
        pl: "Obejrzyj",
        pt: "Assistir",
        ru: "Смотреть",
        tr: "İzle",
        "zh-hans": "观看",
        zh: "觀看",
    },
};

export function dynamicTranslate({
    lang,
    key,
    phaseNumber,
}: {
    lang: string;
    key: string;
    phaseNumber: string;
}) {
    const translations = {
        phase: {
            en: `Phase ${phaseNumber}`,
            de: `Phase ${phaseNumber}`,
            es: `Fase ${phaseNumber}`,
            fr: `Phase ${phaseNumber}`,
            it: `Fase ${phaseNumber}`,
            ja: `フェーズ${phaseNumber}`,
            ko: `${phaseNumber}단계`,
            pl: `Etap ${phaseNumber}`,
            pt: `Fase ${phaseNumber}`,
            ru: `ЭТАП ${phaseNumber}`,
            tr: `${phaseNumber}. Aşama`,
            "zh-hans": `第${phaseNumber}阶段`,
            zh: `第${phaseNumber}階段`,
        },
    };

    return translations[key as keyof typeof translations]
        ? translations[key as keyof typeof translations][
              lang as keyof typeof translations.phase
          ] || translations[key as keyof typeof translations]["en"]
        : key;
}
